import React from 'react'
import styles from './dashboard.module.css'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'

const KycPendingAlert = () => {
    return (
        <React.Fragment>
            <div className='col-sm-12'>
                <div className={`${styles['yellow-top']} d-flex justify-content-between align-items-center`}>
                    <p>Your KYC is still pending, please complete your KYC and enjoy full featured services. </p>
                    <Link className={`${styles['compare-btn']} btn`} to={constant.component.kycForm.url}>Complete now</Link>
                </div>
            </div>
        </React.Fragment>
    )
}

export default KycPendingAlert